import React from 'react'

import {
  Form,
  Input,
  Radio,
  Row,
  Col, Checkbox,
  Button,
  Divider,

} from 'antd';

class Nqfub extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nuqs: this.props.nuqs

    };
  }
  onChangeradio = (e, i) => {
    this.setState({ nuqs: this.basmap(this.state.nuqs, i, e) });
  };
  basmap = (val, i, e) => {
    return val.map((x) => {
      if (i === x.lI_QUEST_NO)
        return { ...x, ans: e.target.value }
      else {
        return x
      }

    })
  }
  componentDidMount() {
    let noN_UNIFORM = this.props.noN_UNIFORM ;
    if (noN_UNIFORM) {
      let bb = noN_UNIFORM.filter(x =>  this.state.nuqs.find(a => a.lI_QUEST_NO === x.keY_VALUE)).map(x => {
        return { ...this.state.nuqs.find(a => a.qno === x.keY_VALUE), ans: x.value }
      });
      this.setState({ bqs: bb });
    }


  }
  render() {
    const { getFieldDecorator } = this.props;
    let  noN_UNIFORM  = this.props.noN_UNIFORM;

    return this.state.nuqs.sort((a,b)=>a.lI_QUEST_NO-b.lI_QUEST_NO).map((x, i) => {
      
      return <div key={i}> <Row>
        <Col sm={20}>
          <p style={{ fontSize: '15px' }} dangerouslySetInnerHTML={{ __html: x.lI_QUEST_NO + ") " + x.lI_QUEST }}></p>
          {x.deS1 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS1 }}></p> : ""}
          {x.deS2 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS2 }}></p> : ""}
          {x.deS3 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS3 }}></p> : ""}
          {x.deS4 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS4 }}></p> : ""}
          {x.deS5 ? <p style={{ background: '#9982821f', padding: '10px' }} dangerouslySetInnerHTML={{ __html: x.deS5 }}></p> : ""}

          {getFieldDecorator(`keY_VALUE[${x.lI_QUEST_NO}]`, {
            initialValue: x.lI_QUEST_NO,
            rules: [{ required: true, message: 'Please enter ' + x.lI_QUEST_NO }],
          })(
            <Input autoComplete={"nope"} className="mi_input" type="text" hidden />)}
        </Col>
        <Col sm={4}>
          <>{x.nQDs.length > 0 && x.nQDs[0].lI_NQA_TYPE === "RB" ?
            <Form.Item key={x.lI_QUEST_NO}>

              {getFieldDecorator(`value[${x.lI_QUEST_NO}]`, {
                initialValue: noN_UNIFORM && noN_UNIFORM.find(a => a.keY_VALUE === x.lI_QUEST_NO) ? noN_UNIFORM.find(a => a.keY_VALUE === x.lI_QUEST_NO).value : 'N',
                rules: [{ required: true, message: 'Please select ' + x.lI_QUEST_NO }],
              })(
                <Radio.Group style={{ marginLeft: "19px" }} onChange={(e) => this.onChangeradio(e, x.lI_QUEST_NO)}>
                  {x.nQDs.map((y, j) => <Radio key={j} value={y.lI_RESPONSE_KEY}>{y.lI_RESPONSE}</Radio>)}
                </Radio.Group>)}</Form.Item> : ""}</>
          <>{x.nQDs.length > 0 && x.nQDs[0].lI_NQA_TYPE === "TXT" ?
            <Form.Item key={x.lI_QUEST_NO}>
              <fieldset className="mi_input_pop">
                <legend className="legend-font"></legend>
                {getFieldDecorator(`value[${x.lI_QUEST_NO}]`, {
                  initialValue: noN_UNIFORM && noN_UNIFORM.find(a => a.keY_VALUE === x.lI_QUEST_NO) ? noN_UNIFORM.find(a => a.keY_VALUE === x.lI_QUEST_NO).value : '',

                  rules: [{ required: true, message: 'Please enter ' + x.lI_QUEST_NO }],
                })(
                  <Input autoComplete={"nope"} className="mi_input" type="text" />)}</fieldset></Form.Item>
            : ""}</>
          <>{x.nQDs.length > 0 && x.nQDs[0].lI_NQA_TYPE === "MCS" ?
            <Form.Item key={x.lI_QUEST_NO}>
              {getFieldDecorator(`value[${x.lI_QUEST_NO}]`, {
                initialValue: noN_UNIFORM && noN_UNIFORM.filter(a => a.keY_VALUE === x.lI_QUEST_NO).length>0 ? noN_UNIFORM.filter(a => a.keY_VALUE === x.lI_QUEST_NO).map(a=>
                {return a.value}) : [x.nQDs[x.nQDs.length-1].lI_RESPONSE_KEY],

                rules: [{ required: true, message: 'Please select ' + x.lI_QUEST_NO }],
              })(
                <Checkbox.Group options={x.nQDs.map((y,i) => { return { label: y.lI_RESPONSE, value: y.lI_RESPONSE_KEY?y.lI_RESPONSE_KEY:i } })} />

              )}</Form.Item> : ""}</>

        </Col>

      </Row>
      <Divider></Divider>
        {x.ans === 'Y' && x.nQs.length > 0 ?
          <Nqfub nuqs={x.nQs} noN_UNIFORM={this.props.noN_UNIFORM} niprappoinment={this.props.niprappoinment} getFieldDecorator={getFieldDecorator}></Nqfub>
          : ""}
       

      </div>
    })
  }
}

class EAD extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      nuqs: this.props.nuqs

    };

  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {

      if (!err) {
        if (values&&(values.value.length > 0||values.value)) {
          let _nuqs = [];
          let { keY_VALUE, value } = values;
          Object.keys(keY_VALUE).forEach(function (i) {
            if (typeof value[i] != "object")
              _nuqs.push({ keY_VALUE: keY_VALUE[i], value: value[i] })
            else {
              Object.keys(value[i]).forEach(function (j) {
                _nuqs.push({ keY_VALUE: keY_VALUE[i], value: value[i][j] })

              });

            }
          });

          this.props.submitHandler(_nuqs);
        } else {
          this.props.submitHandler([]);
        }
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div><Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
        <Row>
          <Col sm={24}>
            <Nqfub nuqs={this.state.nuqs} noN_UNIFORM={this.props.noN_UNIFORM} niprappoinment={this.props.niprappoinment} getFieldDecorator={getFieldDecorator}></Nqfub>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <div className="collapsepanel-footer ">
              <Button className=" ant-btn mi_button_right" style={{ float: "left", marginTop: "-20px", marginLeft: "-11px" }} onClick={() => this.props.back("exp")}> Back</Button>

              <Button className=" ant-btn-primary" htmlType="submit"
                style={{ float: "right", marginTop: "-20px", marginRight: "-11px" }}>
                Next</Button> </div>
          </Col>  </Row>


      </Form>


      </div>

    )
  }
}

const NiprNQ = Form.create()(EAD);

export default NiprNQ;

